import { Navigate } from 'react-router-dom'
import { Dashboard } from '@/pages/dashboard/Dashboard'
import { isStandalonePWA } from '@/utils/pwa'

/**
 * HomeLanding — rota index ("/").
 *
 * No **app instalado** (standalone) ou no **celular** (viewport ≤ 768px), abre
 * direto nas Conversas (/chat) — a visão "WhatsApp da infra". No desktop, mantém
 * o Dashboard. O Dashboard segue acessível pelo menu lateral em ambos os casos.
 *
 * A decisão é síncrona (matchMedia no render) para não piscar o Dashboard antes
 * de redirecionar. É avaliada na navegação para "/", não reativa a resize — o
 * que é o comportamento desejado para uma decisão de landing.
 */
function prefersChatLanding(): boolean {
  if (isStandalonePWA()) return true
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    try {
      return window.matchMedia('(max-width: 768px)').matches
    } catch {
      return false
    }
  }
  return false
}

export function HomeLanding() {
  if (prefersChatLanding()) return <Navigate to="/chat" replace />
  return <Dashboard />
}
